import React from "react";
import { DocEntityMap, DocProps } from "../../Language";
import { GenericTermsKFSV as SV } from "./GenericTermsKFSV";
import "../../Documents.css";

const docsMap: DocEntityMap = { SV };

export const GenericTermsKF: React.FC<DocProps> = (props) =>
  React.createElement(docsMap[props.language], props);
